import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faApple, faGooglePlay, faInstagram, faFacebook, faTiktok, faDiscord } from '@fortawesome/free-brands-svg-icons';
import { Link } from 'react-router-dom'; // Import Link from react-router-dom
import '../StylesComponents/footer.css';

function Footer() {
  return (
    <footer className="footer">
      <div className="footer-container">
        <div className="footer-links">
          <Link to="/contact" className="footer-link-active">Contact Us</Link>
          <Link to="/terms" className="footer-link-active">Terms of Service</Link>
          <Link to="/privacy" className="footer-link-active">Privacy Policy</Link>
        </div>
        <div className="app-download">
          <div className="inactive-footer-app-btn">
            <FontAwesomeIcon icon={faApple} size="2x" />
            <span> App Store</span>
          </div>
          <div className="inactive-footer-app-btn">
            <FontAwesomeIcon icon={faGooglePlay} size="2x" />
            <span> Google Play</span>
          </div>
        </div>
        <div className="footer-socials">
          <a href="https://www.instagram.com/thestockroomau/" target="_blank" rel="noopener noreferrer"><FontAwesomeIcon icon={faInstagram} /></a>
          <a href="https://www.facebook.com/profile.php?id=61563686767903" target="_blank" rel="noopener noreferrer"><FontAwesomeIcon icon={faFacebook} /></a>
          <a href="https://www.tiktok.com/@stockroomau" target="_blank" rel="noopener noreferrer"><FontAwesomeIcon icon={faTiktok} /></a>
          <a href="https://discord.gg/q4vbdGW5" target="_blank" rel="noopener noreferrer" className="footer-discord"><FontAwesomeIcon icon={faDiscord} /></a>
        </div>
        <div className="footer-copy">
          <p>&copy; 2026 Stockroom. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
